import { combineReducers } from 'redux'
import users from './users'
import presentations from './presentations'
import ui from './ui'
import queries from './queries'
import databases from './databases'
import selfServeJobs from './selfServeJobs'

export default combineReducers({
    users: users,
    presentations: undoable(presentations),
    queries: undoable(queries),
    databases: databases,
    selfServeJobs: selfServeJobs,
    ui,
})

function undoable(reducer) {
    // Call the reducer with empty action to populate the initial state
    const initialState = {
        past: [],
        present: reducer(undefined, {}),
        future: []
    }

    // Return a reducer that handles undo and redo
    return function (state = initialState, action) {
        const { past, present, future } = state
        switch (action.type) {
            case 'UNDO':
                const previous = past[past.length - 1]
                const newPast = past.slice(Math.max(past.length - 10, 1))
                return {
                    past: newPast,
                    present: previous,
                    future: [present, ...future]
                }
            case 'REDO':
                const next = future[0]
                const newFuture = future.slice(1)
                return {
                    past: [...past, present],
                    present: next,
                    future: newFuture
                }
            default:
                // Delegate handling the action to the passed reducer
                const newPresent = reducer(present, action)
                if (present === newPresent) {
                    return state
                }
                return {
                    past: [...past, present],
                    present: newPresent,
                    future: []
                }
        }
    }
}